<template>
    <span class="inline-flex h-7 w-7 items-center justify-center">
        <span
            v-if="enabled"
            :class="changed ? 'bg-white text-green-600 ring-2 ring-amber-400' : 'bg-green-600 text-white'"
            class="inline-flex h-5 w-5 items-center justify-center rounded-full"
        >
            <icon class="!h-3 !w-3" icon="cil-check-alt" size="sm" />
        </span>
        <span
            v-else
            :class="changed ? 'ring-2 ring-amber-400' : ''"
            class="inline-flex h-5 w-5 items-center justify-center rounded-full border border-gray-300 bg-white"
        ></span>
    </span>
</template>

<script setup>
defineProps({
    enabled: { type: Boolean, default: false },
    changed: { type: Boolean, default: false },
});
</script>
